module.exports = __webpack_public_path__ + "img/pennellata-top.73a63e38.jpg";